import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleModal } from '../store/actions/toggleModalActions';
import {getStatusColor, isCompanyAdmin, isSuperAdmin} from "../helpers/helpers";
import './CommunitySensorModal.scss';
import ButtonSpinner from "./_common/ButtonSpinner";
import {addCommunitySensor} from "../store/actions/communitySensorsActions";
import SensorsMap from "./SensorsMap";
import {getSensorDetails} from "../store/actions/sensorsActions";
import Spinner from "./_common/Spinner";
import MapView from "./Maps/MapView";

const selector = state => {
    const { language, disableButtons, sensors, modalState } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        details: sensors.details,
        detailsPending: sensors.detailsPending
    }
};

const CommunitySensorModal = props => {
    const { sensor } = props;
    const { t, disableButtons, details, detailsPending } = useSelector(selector);
    const dispatch = useDispatch();

    const [formValues, setFormValues] = useState(
        {
            name: '',
            lat: sensor.lat,
            lon: sensor.lon,
            realSensorId: sensor.id,
            realSensorLoraId: sensor.loraIdentifier,
            communityFieldName: '',
            createNewCommunityField: true,
            communityFieldLat: sensor.lat,
            communityFieldLon: sensor.lon
        }
    );
    const [mapHasBeenClicked, setMapHasBeenClicked] = useState(false);

    useEffect(() => {
        dispatch(getSensorDetails(sensor.id));
    }, [sensor]);

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const handleAddCommunitySensorClick = () => {
        dispatch(addCommunitySensor(formValues));
    }

    const sensorMarker = [
        {
            lat: sensor.lat,
            lng: sensor.lon,
            color: getStatusColor(sensor.temperatureStatus),
            name: sensor.name,
            loraIdentifier: sensor.loraIdentifier,
            temperature: sensor.temperature,
            humidity: sensor.measurements.length ? sensor.measurements[0].humidity : '',
            date: sensor.measurements.length ? sensor.measurements[0].dateTimeCreated.replace('T') : '',
            id: sensor.id
        }
    ];

    const getCoordinatesFromMap = (latlng) => {
        setMapHasBeenClicked(true);
        setFormValues({ ...formValues, lat: latlng.lat, lon: latlng.lng, communityFieldLat: latlng.lat, communityFieldLon: latlng.lng })
    };

    return (
        <div
            className='communitySensorModalBlur'
            onClick={e => {
                if(e.target.className === 'sensorModalBlur') {
                    closeModal()
                }
            }}
        >
            <div className='communitySensorModal'>
                <div className='sensorModalHeader'>
                    <div className='sensorModalTitleContainer'>
                        <div className='sensorModalTitle'>
                            {t.gettext('Add New Community Sensor')}
                        </div>
                    </div>
                    <div className='sensorModalCloseButtonHolder'>
                        <span
                            className='material-icons sensorModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div className='sensorModalContent'>
                    {!details || details.id !== sensor.id
                        ? <Spinner size={300} />
                        : <form className='sensorModalForm' autoComplete='off'>
                            <div className='sensorMap'>
                                <MapView
                                    zoom={12}
                                    center={{
                                        lat: sensor.lat ? sensor.lat : 52.2297,
                                        lng: sensor.lon ? sensor.lon : 21.0122
                                    }}
                                    markers={sensorMarker}
                                    getCoordinates={getCoordinatesFromMap}
                                    mapHasBeenClicked={mapHasBeenClicked}
                                />
                                {/*<SensorsMap*/}
                                {/*    defaultZoom={12}*/}
                                {/*    defaultCenter={{*/}
                                {/*        lat: sensor.lat ? sensor.lat : 52.2297,*/}
                                {/*        lng: sensor.lon ? sensor.lon : 21.0122*/}
                                {/*    }}*/}
                                {/*    markers={sensorMarker}*/}
                                {/*    getCoordinatesFromMap={getCoordinatesFromMap}*/}
                                {/*    clickMarkerData={mapHasBeenClicked*/}
                                {/*        ? {*/}
                                {/*            lat: formValues.lat,*/}
                                {/*            lng: formValues.lon,*/}
                                {/*            color: '#E628B3'*/}
                                {/*        }*/}
                                {/*        : null*/}
                                {/*    }*/}
                                {/*    clickMarkerMap*/}
                                {/*/>*/}
                            </div>
                            <div className='sensorModalFormMapInfo'>
                                {t.gettext('Click on the map to obtain coordinates')}
                            </div>
                            <div className='sensorModalFormRealSensorInfo'>
                                <div className='sensorModalFormRealSensorInfoItem'>
                                    {t.gettext('Real Sensor Name')}: <span>{details?.name}</span>
                                </div>
                                <div className='sensorModalFormRealSensorInfoItem'>
                                    {t.gettext('Real Sensor Field Name')}: <span>{details?.fieldName}</span>
                                </div>
                                <div className='sensorModalFormRealSensorInfoItem'>
                                    {t.gettext('Real Sensor Owner')}: <span>{details?.ownerName}</span>
                                </div>
                            </div>
                            <div className='sensorModalFormItem'>
                                <label className='sensorModalFormLabel'>
                                    {t.gettext('Community Sensor Name')}
                                </label>
                                <input
                                    className='sensorModalFormInput'
                                    defaultValue={formValues.name}
                                    onInput={e => {
                                        setFormValues({...formValues, name: e.target.value});
                                    }}
                                    type='text'
                                />
                            </div>
                            <div className='sensorModalFormRow'>
                                <div className='sensorModalFormItem'>
                                    <label className='sensorModalFormLabel'>
                                        {t.gettext('Sensor Latitude')}
                                    </label>
                                    <input
                                        className='sensorModalFormInput'
                                        value={formValues.lat}
                                        onChange={e => {
                                            setFormValues({...formValues, lat: e.target.value});
                                        }}
                                        type='number'
                                    />
                                </div>
                                <div className='sensorModalFormItem'>
                                    <label className='sensorModalFormLabel'>
                                        {t.gettext('Sensor Longitude')}
                                    </label>
                                    <input
                                        className='sensorModalFormInput'
                                        value={formValues.lon}
                                        onChange={e => {
                                            setFormValues({...formValues, lon: e.target.value});
                                        }}
                                        type='number'
                                    />
                                </div>
                            </div>
                            <div className='sensorModalFormItem'>
                                <label className='sensorModalFormLabel'>
                                    {t.gettext('Community Field Name')}
                                </label>
                                <input
                                    className='sensorModalFormInput'
                                    defaultValue={formValues.communityFieldName}
                                    onInput={e => {
                                        setFormValues({...formValues, communityFieldName: e.target.value});
                                    }}
                                    type='text'
                                />
                            </div>
                            <div className='sensorModalFormRow'>
                                <div className='sensorModalFormItem'>
                                    <label className='sensorModalFormLabel'>
                                        {t.gettext('Field Latitude')}
                                    </label>
                                    <input
                                        className='sensorModalFormInput'
                                        value={formValues.communityFieldLat}
                                        onChange={e => {
                                            setFormValues({...formValues, communityFieldLat: e.target.value});
                                        }}
                                        type='number'
                                    />
                                </div>
                                <div className='sensorModalFormItem'>
                                    <label className='sensorModalFormLabel'>
                                        {t.gettext('Field Longitude')}
                                    </label>
                                    <input
                                        className='sensorModalFormInput'
                                        value={formValues.communityFieldLon}
                                        onChange={e => {
                                            setFormValues({...formValues, communityFieldLon: e.target.value});
                                        }}
                                        type='number'
                                    />
                                </div>
                            </div>
                            <div className='sensorButtonsHolder'>
                                <button
                                    className='sensorAddButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleAddCommunitySensorClick();
                                    }}
                                    disabled={
                                        disableButtons ||
                                        (
                                            !formValues.name ||
                                            !formValues.lat ||
                                            !formValues.lon ||
                                            !formValues.communityFieldName ||
                                            !formValues.communityFieldLat ||
                                            !formValues.communityFieldLon
                                        )
                                    }
                                >
                                    {t.gettext('Add Community Sensor')}
                                    {disableButtons && <ButtonSpinner black/>}
                                </button>
                            </div>
                        </form>
                    }
                </div>
            </div>
        </div>
    );
};

export default CommunitySensorModal;
